import React from 'react';
import DropDownItem from './DropDownItem';
import { useLocation } from 'react-router-dom';

interface DropDownProps {
  navDropDown: boolean;
  toggleNavMobile: () => void;
}

const DropDown: React.FC<DropDownProps> = ({
  navDropDown,
  toggleNavMobile,
}) => {
  const currentLocation = useLocation();
  const loc =
    currentLocation.pathname === '/' ? 'home' : currentLocation.pathname;

  const currentLoc = loc === 'home' ? 'home' : loc.slice(1);
  const location = currentLoc.charAt(0).toUpperCase() + currentLoc.slice(1);

  return (
    <>
      {!navDropDown && (
        <DropDownItem route={location} onClick={toggleNavMobile}></DropDownItem>
      )}

      {navDropDown && (
        <>
          <DropDownItem
            route="Home"
            id={2}
            onClick={toggleNavMobile}
          ></DropDownItem>
          <DropDownItem
            route="Projects"
            id={3}
            onClick={toggleNavMobile}
          ></DropDownItem>
          <DropDownItem
            route="Calendar"
            id={1}
            onClick={toggleNavMobile}
          ></DropDownItem>
          <DropDownItem
            id={4}
            route="Contact"
            onClick={toggleNavMobile}
          ></DropDownItem>
        </>
      )}
    </>
  );
};

export default DropDown;
